import { Box, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet-async"
import { Link } from "react-router-dom"

import { PageTitle } from "@jewlr/storybook/info"
import { jewlr_t } from "helpers/application"

const InfoLayoutNew = ({
  children,
  hidePageTitle,
  isNewDesign,
  layout,
  title,
}) => (
  <>
    <Helmet
      defaultTitle={`${jewlr_t("terms.Personalized")} ${jewlr_t(
        "terms.Jewelry"
      )} | Custom Gemstones & Engravings`}
      prioritizeSeoTags
      titleTemplate="%s | Jewlr"
    >
      <title>{title}</title>
    </Helmet>
    <Box contain>
      <Typography
        color="neutral"
        fontSize="14px"
        light
        my={3}
        textAlign={{ _: "center", tablet: "left" }}
      >
        <Link data-lc="info-layout-new" to="/">
          Home
        </Link>{" "}
        /{" "}
        {layout === "press" && (
          <>
            <Link data-lc="info-layout-new" to="/info/press">
              Press
            </Link>{" "}
            /{" "}
          </>
        )}
        {title}
      </Typography>
      {!hidePageTitle && (
        <PageTitle isNewDesign={isNewDesign}>{title}</PageTitle>
      )}
    </Box>
    {children}
  </>
)

InfoLayoutNew.propTypes = {
  children: PropTypes.element.isRequired,
  hidePageTitle: PropTypes.bool,
  isNewDesign: PropTypes.bool,
  layout: PropTypes.string,
  title: PropTypes.string.isRequired,
}

export default InfoLayoutNew
